import {PatientBaseInformation} from '@domain/appointments/appointments';
import {WorkingDays} from '@domain/working-days';

export interface Appointment
{
    id: string;
    date: string;
    patient: PatientBaseInformation;
    clinic: string;
    speciality: string;
    location: string;
}

export type Appointments = Appointment[];

export interface UnavailableSlot
{
    id: string;
    startDate: string;
    endDate: string;
}

export type UnavailableSlots = UnavailableSlot[];

export class Agenda
{
    public readonly workingDays: WorkingDays;

    public readonly appointments: Appointments;

    public readonly unavailableSlots: UnavailableSlots;

    public constructor(
        workingDays: WorkingDays,
        appointments: Appointments,
        unavailableSlots: UnavailableSlots
    )
    {
        this.workingDays = workingDays;
        this.appointments = appointments;
        this.unavailableSlots = unavailableSlots;
    }

    public static fromJSON(agendaJSON: any): Agenda
    {
        return new Agenda(
            agendaJSON?.workingDays?.length ? agendaJSON?.workingDays : [],
            agendaJSON?.appointments?.length ? agendaJSON?.appointments : [],
            agendaJSON?.unavailableSlots?.length ? agendaJSON?.unavailableSlots : []
        );
    }
}
